import { styled } from 'styled-components';
import { Trigger as RadixTabsTrigger } from '@radix-ui/react-tabs';
import { segmentedControlItemStyles } from '../SegmentedControl/SegmentedControlItem';

type StyledTabsTriggerProps = {
  $hasLabel?: boolean;
};

export const StyledTabsTrigger = styled(RadixTabsTrigger)<StyledTabsTriggerProps>`
  ${segmentedControlItemStyles}

  &:focus-visible {
    outline: none;
  }
`;
